<template>
    <div id="new_status_prototype">
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="true"></ErrorMessages>
        <div class="contents ui container" v-if="is_initialized">
            <div v-if="is_loading" class="ui active centered inline loader"></div>
            <div class="ui form" v-else>
                <div class="field computer column">
                    <div class="ui radio checkbox">
                        <input type="radio" v-model="status_prototype.polarity" :value="null" id="no_polarity">
                        <label for="no_polarity" class="pointer"><i class="help icon"></i>
                            <!-- 無極性 -->
                            {{ $t('models.attributes.status_prototypes.non_polarity') }}
                        </label>
                    </div>
                    <div class="ui radio checkbox">
                        <input type="radio" v-model="status_prototype.polarity" :value="true" id="true_polarity">
                        <label for="true_polarity" class="pointer"><i class="plus icon"></i>
                            <!-- 正極性 -->
                            {{ $t('models.attributes.status_prototypes.positive_polarity') }}
                        </label>
                    </div>
                    <div class="ui radio checkbox">
                        <input type="radio" v-model="status_prototype.polarity" :value="false" id="false_polarity">
                        <label for="false_polarity" class="pointer"><i class="minus icon"></i>
                            <!-- 負極性 -->
                            {{ $t('models.attributes.status_prototypes.negative_polarity') }}
                        </label>
                    </div>
                </div>

                <div class="field">
                    <label>{{ $t('models.attributes.status_prototypes.name') }}</label>
                    <input type="text" name="name" v-model="status_prototype.name">
                </div>
                <div class="field computer column">
                    <label>{{ $t('models.attributes.status_prototypes.description') }}</label>
                    <input type="text" name="description" v-model="status_prototype.description">
                </div>
                <div class="field">
                    <label>Scope</label>
                    <select class="ui mini dropdown" v-dropdown v-model="status_prototype.scope">
                        <option value="">{{ $t('ui.general.please_select') }}</option>
                        <option v-for="option in scope_options" :value="option.scope">{{ option.name }}</option>
                    </select>
                </div>
                <div class="field">
                    <label>MaterialClassName</label>
                    <input type="text" name="material_class_name" v-model="status_prototype.material_class_name">
                </div>
                <div class="ui basic fluid positive button" @click="create_status_prototype">
                    {{ $t('ui.general.submit') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ErrorMessages from '@toolbox/error_box/main.vue'
export default {
    name: "NewStatusPrototype",
    data() {
        return {
            is_initialized: false,
            is_loading: false,
            errors: [],
            status_prototype: {
                polarity: null,
                scope: "operator",
            },
        }
    },
    computed: {
        scope_options() {
            return [
                {name: this.$t('ui.status_scopes.system')   , scope: "system"},
                {name: this.$t('ui.status_scopes.mark')     , scope: "mark"},
                {name: this.$t('ui.status_scopes.condition'), scope: "condition"},
                {name: this.$t('ui.status_scopes.operator') , scope: "operator"},
                {name: this.$t('ui.status_scopes.forwarder'), scope: "forwarder"},
                {name: this.$t('ui.status_scopes.public')   , scope: "public"},
            ]
        }
    },
    created() {
    },
    mounted() {
        this.init()
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                resolve()
            })
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
        create_status_prototype() {
            this.is_loading = true
            this.errors = []
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_status_prototypes_create).parse({
                "status_prototype_identity": this.$route.params.identity,
            })

            axios.post(url, this.status_prototype, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.status_prototype = response.data.status_prototype
                        // this.$noty.success("建立成功")
                        this.$noty.success(
                            this.$t('ui.notifications.success.create__name', {
                                name: this.$t('models.status_prototypes')
                            })
                        )
                        this.$router.push({name: 'status_prototypes'})
                    } else {
                        console.log(response.data)
                        this.$noty.error(response.data)
                    }
                })
                .catch(error => {
                    console.log(error.response)
                    this.$noty.error(error.response)
                })
                .then(() => {
                    setTimeout(() => {
                        this.is_loading = false
                    }, 300)
                })
        }
    },
    components: {
        ErrorMessages,
    }
}
</script>

<style scoped lang="scss">
</style>
